import { Route, Routes } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import RegisterForm from './components/RegisterForm';
import NotFound from './components/NotFound';
import Login from './components/Login';
import GenerateQR from './components/GenerateQR';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/register" element={<RegisterForm />} />
      <Route path="/login" element={<Login />} />
      <Route path="/generateQR" element={<GenerateQR />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;